module.exports = "https://static.wanderu.com/ui-react/_next/static/media/booking.995c4884.png";